// extracted by mini-css-extract-plugin
export default {"sectionTitle2":"SectionTitleTwo_sectionTitle2__3P8G5"};